import React from 'react';
import PropTypes from 'prop-types';
import StatList from './StatList';
import CardVideo from './CardVideo';
import { statsMainType } from '../proptypes/special-ops';

const SpecialOpsVideoSlide = ({
  stats,
  sessionId,
  setVideoRef,
  specialOpsVideoUrl,
  onPlay,
  isVideoBeingProcessed,
}) => (
  <>
    <StatList
      {...stats}
      classNames="stat-pair-space-between stat-pair"
    />
    {sessionId && (
      <CardVideo
        sessionId={sessionId}
        setVideoRef={setVideoRef}
        videoUrlPath={specialOpsVideoUrl}
        onPlay={onPlay}
        isVideoBeingProcessed={isVideoBeingProcessed}
      />
    )}
  </>
);

SpecialOpsVideoSlide.propTypes = {
  stats: statsMainType.isRequired,
  sessionId: PropTypes.string.isRequired,
  setVideoRef: PropTypes.func,
  specialOpsVideoUrl: PropTypes.string.isRequired,
  onPlay: PropTypes.func,
  isVideoBeingProcessed: PropTypes.bool.isRequired,
};

SpecialOpsVideoSlide.defaultProps = {
  setVideoRef: () => {},
  onPlay: undefined,
};

export default SpecialOpsVideoSlide;
